import { authToken, teladocApi } from '@td/api';

const requestDefaults = {
  action_cd: "DATAAUTOMATIONACTION_QUARANTINE",
  actor_poly_type_cd: "MRN",
  job_type_cd: "JOBTYPE_JIRA",
  priority: 90
}

const validateQuarantineAction = (mrnId, teamSupportTicket) => {
  const request = {
    elig_mrn_id: mrnId,
    team_support_ticket: teamSupportTicket,
    ...requestDefaults
  }
  return teladocApi.post('/v4/data_automation_triggers/validate', request, authToken.get());
};

export default validateQuarantineAction;